import { Component, Vue, Prop } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faClose, faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import api from '@/helpers/fetch'
import AWS from 'aws-sdk'
import Fuse from 'fuse.js'

library.add(faClose, faTrashAlt)

const bucketName = 'portal-conteudos-laminas'
const bucketRegion = 'sa-east-1'
const IdentityPoolId = 'sa-east-1:bc7f9ff6-d461-4870-b480-29756e9502e9'

let s3 = null as any

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class CreateModal extends Vue {
	@Prop({ required: true }) tags!: Array<any>

	modalLoading = false
	submitLoading = false
	form = {
		title: '',
		desc: '',
		file: null as unknown as File,
		tag: '',
		content_tags: [] as Array<any>,
	}

	awsSetup() {
		AWS.config.update({
			region: bucketRegion,
			credentials: new AWS.CognitoIdentityCredentials({
				IdentityPoolId: IdentityPoolId,
			}),
		})

		s3 = new AWS.S3({
			apiVersion: '2006-03-01',
			params: { Bucket: bucketName },
		})
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	clearForm() {
		this.form.title = ''
		this.form.desc = ''
		this.form.file = null as unknown as File
		this.form.content_tags = []
		this.modalLoading = false
		this.$emit('hidden')
	}

	addTag() {
		const tag = this.tags.find((tag) => tag.id === this.form.tag)

		const found = this.form.content_tags.find(
			(selectedTag) => selectedTag.id === tag.id,
		)

		if (found) {
			this.$bvToast.toast('Tag já selecionada', {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
		} else {
			this.form.content_tags.push(tag)
		}

		this.form.tag = ''
	}

	removeTag(index) {
		this.form.content_tags.splice(index, 1)
	}

	uploadPdf(callback) {
		const emptyPdfUrl = ''

		// timestamp-randomString_originalFilename
		const fileName =
			Date.now() +
			'-' +
			Math.round(Math.random() * 1e5) +
			'_' +
			this.form.file.name

		s3.upload(
			{
				Bucket: bucketName,
				Key: fileName,
				Body: this.form.file,
				ContentType: this.form.file.type,
			},
			(err, data) => {
				/**
				 * data: {
				 *   Bucket, (bucket name)
				 *   ETag, (random string)
				 *   Key, (filename)
				 *   Location, (full url)
				 *   key, (filename)
				 * }
				 */
				if (err) {
					this.$bvToast.toast(
						'Não foi possível fazer upload do pdf. ' + err,
						{
							title: 'Erro',
							variant: 'danger',
							solid: true,
							toaster: 'b-toaster-top-center',
						},
					)
				} else {
					callback(data.Location)
				}
			},
		)
	}

	async submit() {
		if (!this.form.title) {
			this.$bvToast.toast('Preencha um título', {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})

			return false
		}

		if (!(this.form.file instanceof File)) {
			this.$bvToast.toast('Selecione um arquivo', {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})

			return false
		}

		this.submitLoading = true
		this.uploadPdf(async (pdfUrl) => {
			const formData = {
				title: this.form.title,
				desc: this.form.desc,
				tags: this.form.content_tags.map((contentTag) => contentTag.id),
				url: pdfUrl,
			}

			const res = await api.post(
				'/api/blogging/content-laminas/',
				formData,
			)
			this.submitLoading = false
			if (res.ok) {
				this.$bvToast.toast('Lâmina inserida!', {
					title: 'Sucesso!',
					variant: 'success',
					solid: true,
					toaster: 'b-toaster-top-center',
				})
				this.$bvModal.hide('create-lamina')
			} else {
				this.$bvToast.toast(res.msg, {
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				})
			}
		})
	}

	mounted() {
		this.awsSetup()
	}
}
